/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetSupportingExaminationDictDto } from './GetSupportingExaminationDictDto';
import {
    GetSupportingExaminationDictDtoFromJSON,
    GetSupportingExaminationDictDtoFromJSONTyped,
    GetSupportingExaminationDictDtoToJSON,
} from './GetSupportingExaminationDictDto';

/**
 * 
 * @export
 * @interface GetHarmfulFactorSuppExamDictDto
 */
export interface GetHarmfulFactorSuppExamDictDto {
    /**
     * 
     * @type {string}
     * @memberof GetHarmfulFactorSuppExamDictDto
     */
    id: string;
    /**
     * 
     * @type {GetSupportingExaminationDictDto}
     * @memberof GetHarmfulFactorSuppExamDictDto
     */
    supportingExaminationDict: GetSupportingExaminationDictDto;
}

/**
 * Check if a given object implements the GetHarmfulFactorSuppExamDictDto interface.
 */
export function instanceOfGetHarmfulFactorSuppExamDictDto(value: object): value is GetHarmfulFactorSuppExamDictDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('supportingExaminationDict' in value) || value['supportingExaminationDict'] === undefined) return false;
    return true;
}

export function GetHarmfulFactorSuppExamDictDtoFromJSON(json: any): GetHarmfulFactorSuppExamDictDto {
    return GetHarmfulFactorSuppExamDictDtoFromJSONTyped(json, false);
}

export function GetHarmfulFactorSuppExamDictDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetHarmfulFactorSuppExamDictDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'supportingExaminationDict': GetSupportingExaminationDictDtoFromJSON(json['supportingExaminationDict']),
    };
}

export function GetHarmfulFactorSuppExamDictDtoToJSON(value?: GetHarmfulFactorSuppExamDictDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'supportingExaminationDict': GetSupportingExaminationDictDtoToJSON(value['supportingExaminationDict']),
    };
}

